const searchTypes = {
    suggestion: 'term',
    product: 'product'
};

export function serializeSuggestions(payload) {
    return payload
        .filter((item) => item.type === searchTypes.suggestion)
        .map((item) => ({
            title: item.title || '',
            foundItems: item.num_results || ''
        }));
}

export function serializeProducts(payload) {
    return payload
        .filter((item) => item.type === searchTypes.product)
        .map((item) => ({
            title: item.title || '',
            description: item.description_claim || '',
            price: item.price || '',
            img: item.image || '',
            link: item.url || ''
        }));
}
